import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import {styled} from '@mui/material/styles';

export const StyledSectionContentContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  position: 'relative'
}));

export const StyledPointsChip = styled(Chip)(({theme}) => ({
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(1),
  borderColor: theme.palette.grey[300],
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.caption.fontSize
  }
}));

export const BasketProductWrapper = styled(Box)<{isReactNativeView?: boolean; isFlexibleBasketEnabled?: boolean}>(
  ({theme, isReactNativeView, isFlexibleBasketEnabled}) => ({
    paddingLeft: isFlexibleBasketEnabled ? (isReactNativeView ? theme.spacing(1) : theme.spacing(2)) : theme.spacing(4),
    paddingRight: isFlexibleBasketEnabled ? (isReactNativeView ? theme.spacing(1) : theme.spacing(2)) : theme.spacing(4)
  })
);

export const StyledSectionWrap = styled(Box)<{isReactNativeView?: boolean; isFlexibleBasketEnabled?: boolean}>(
  ({theme, isFlexibleBasketEnabled, isReactNativeView}) => ({
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    position: 'relative',
    margin: isFlexibleBasketEnabled ? (isReactNativeView ? '8px' : '20px') : '',
    maxWidth: isFlexibleBasketEnabled ? '-webkit-fill-available' : '',
    borderRadius: isFlexibleBasketEnabled ? '12px' : '',
    backgroundColor: theme.palette.common.white,
    '&.multiple': {
      [theme.breakpoints.down('md')]: {
        marginBottom: isReactNativeView ? theme.spacing(1) : theme.spacing(2)
      }
    },
    '&.v2': {
      marginBottom: !isFlexibleBasketEnabled ? theme.spacing(0.15) : ''
    }
  })
);
